import { faCheckCircle } from "@fortawesome/pro-solid-svg-icons/faCheckCircle";
import { faExclamationCircle } from "@fortawesome/pro-solid-svg-icons/faExclamationCircle";
import { faInfoCircle } from "@fortawesome/pro-solid-svg-icons/faInfoCircle";
import { faTimes } from "@fortawesome/pro-solid-svg-icons/faTimes";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Alert, IconButton, Snackbar } from "@vapor/react-material";
import React, { useState } from "react";
import { faCircleMinus } from "@fortawesome/pro-solid-svg-icons/faCircleMinus";

const types = {
    success: {
        name: "success",
        icon: faCheckCircle
    },
    info: {
        name: "info",
        icon: faInfoCircle
    },
    error: {
        name: "error",
        icon: faCircleMinus
    },
    warning: {
        name: "warning",
        icon: faExclamationCircle
    }
};

export enum WsSnackbarTypes {
    success = "success",
    info = "info",
    error = "error",
    warning = "warning"
}

interface WsSnackbarProps {
    position?: any;
    sx?: any;
    autoHideDuration?: number;
    handleClose?: () => void;
    open?: boolean;
    type?: keyof typeof WsSnackbarTypes;
    title?: "string" | React.ReactNode;
    message?: "string" | React.ReactNode;
    horizontal?: "right" | "left" | "center";
    vertical?: "top" | "bottom";
}

const WsSnackbar = ({
    position,
    sx,
    autoHideDuration,
    handleClose,
    open,
    type,
    title,
    message,
    horizontal,
    vertical
}: WsSnackbarProps) => {
    const [openState, setOpenState] = useState<boolean>(open ?? true);

    const onClose = () => {
        setOpenState(false);
    };

    return (
        <Snackbar
            anchorOrigin={{
                horizontal: horizontal || "right",
                vertical: vertical || "top"
            }}
            sx={{ position: position || "fixed", ...sx }}
            autoHideDuration={autoHideDuration}
            onClose={handleClose || onClose}
            open={handleClose ? open : openState}
        >
            <Alert
                action={
                    <IconButton onClick={handleClose || onClose} size="small">
                        <FontAwesomeIcon icon={faTimes} />
                    </IconButton>
                }
                icon={<FontAwesomeIcon icon={types[type ?? "info"]?.icon} />}
                severity={type ? WsSnackbarTypes?.[type] : "info"}
                variant="outlined"
                sx={{ width: "100%" }}
            >
                {title && <strong>{title}</strong>}
                {title && <strong>{": "}</strong>}
                {message}
            </Alert>
        </Snackbar>
    );
};

WsSnackbar.defaultProps = {
    autoHideDuration: 6000,
    open: true,
    type: "info",
    horizontal: "right",
    vertical: "top"
};

export default WsSnackbar;
